<template>
	<tr>
		<td>
			<b-link
				href="#"
				@click.prevent="onUpdateClick"
			>{{ customer.Name ? customer.Name : 'Name missing!' }}</b-link>
		</td>

		<td><span
				v-for="(clock, index) in customer.Clocks"
				:key="clock.Id"
			>
				{{ clock.Name }} <span v-if="index != (customer.Clocks.length - 1)">,</span>
			</span>
		</td>

		<td>{{ customer.Reference }}</td>

		<td align="center">
			<b-icon font-scale="1.5" :icon="serviceClass"></b-icon>
		</td>

	</tr>
</template>
<script>
export default {
	name: "CustomerListRow",

	props: ["customer"],

	computed: {
		serviceClass: function() {
			
			let tempClass = "x-circle";

			if (this.customer.ServiceContracts.length) {
				tempClass = "check-circle";

				this.customer.ServiceContracts.forEach((contract, i) => {
					switch (contract.Status) {
						case "Paused":
							tempClass = "pause";
							break;
						case "Ended":
							tempClass = "dash-circle";
							break;
					}
				});
			}

			return tempClass;
		}
	},

	methods: {
		onUpdateClick() {
			this.$emit("update", this.customer.Id);
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/customer/customer-list-row.vue